import {isString} from 'lodash';
import initializeTierOptions from 'Map/configurer/initializeTierOptions';
import {trafficIncidentsStyleSchemaParser} from './styleOptionInitialization/tierStyleSchemaParser';
import {isStylePlainObject} from './styleOptionInitialization/validators';
import ThemeWrapper from './styleOptionInitialization/themeWrapper';

const validateIncidentDetailsOptions = (options) => {
    if (!options) {
        return undefined;
    }

    const incidentDetailsOptions = {...options};

    if (!incidentDetailsOptions.style) {
        incidentDetailsOptions.style = 's1';
    }

    if (typeof incidentDetailsOptions.cssStyleCheck === 'undefined') {
        incidentDetailsOptions.cssStyleCheck = true;
    }

    return incidentDetailsOptions;
};

const validateIncidentTilesOptions = (options) => {
    if (!options) {
        return undefined;
    }

    const incidentTilesOptions = {...options};

    if (isStylePlainObject(incidentTilesOptions.style)) {
        incidentTilesOptions.theme = new ThemeWrapper(ThemeWrapper.TYPE.OBJECT, {
            styleObject: options.style
        });
    } else if (isString(incidentTilesOptions.style)) {
        incidentTilesOptions.theme = trafficIncidentsStyleSchemaParser(options.style);
    }

    return incidentTilesOptions;
};

export default function(inputOptions) {
    if (!inputOptions) {
        return null;
    }
    const options = initializeTierOptions(inputOptions);

    options.incidentDetails = validateIncidentDetailsOptions(options.incidentDetails);
    options.incidentTiles = validateIncidentTilesOptions(options.incidentTiles);

    options.refresh = !options.refresh || options.refresh < 30000 ? 30000 : options.refresh;

    return options;
}



// WEBPACK FOOTER //
// ./map/configurer/initializeTrafficIncidentsOptions.js